export { calculateStabilizerComposition } from "@/lib/ingredients/form-estimators";
import { UnitInput } from "@/components/primitives/unit-input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { clamp, toNumber } from "@/lib/utils";
import { UseFormReturn } from "react-hook-form";
import { CreateIngredientFormData } from "./schema";
import { SimpleFormWrapper } from "./simple-wrapper";

type SimpleFormProps = {
  form: UseFormReturn<CreateIngredientFormData>;
};

export function SimpleStabilizerForm({ form }: SimpleFormProps) {
  const waterPctValue = form.watch("waterPct");
  const solidsPct = 100 - waterPctValue;

  return (
    <SimpleFormWrapper form={form} selectedCategory="stabilizer">
      <FormField
        control={form.control}
        name="stabilizerPct"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Stabilizer %</FormLabel>
            <FormDescription>
              What percentage of this ingredient functions as stabilizer? This
              is usually 100%, but may be lower for stabilizer blends.
            </FormDescription>
            <FormControl>
              <UnitInput {...field} unit="%" min={0} max={100} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="waterPct"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Solids %</FormLabel>
            <FormControl>
              <UnitInput
                {...field}
                unit="%"
                min={0}
                max={100}
                value={solidsPct}
                onChange={(e) => {
                  const waterValue = clamp(
                    100 - toNumber(e.target.value),
                    0,
                    100,
                  );
                  field.onChange(waterValue);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </SimpleFormWrapper>
  );
}
